import { LANES } from "@/pages/services/laneData";

const RECOMMENDATION_CODE = "recommendation";
const RECOMMENDATION_LABEL = "Need the right recommendation";

function slugifyOffer(name) {
  return name
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "");
}

export const CONTACT_SERVICE_OPTION_GROUPS = [
  {
    group: "Quick",
    options: [{ code: RECOMMENDATION_CODE, label: RECOMMENDATION_LABEL }],
  },
  ...Object.values(LANES).map((lane) => ({
    group: lane.title,
    options: lane.offers.map((offer) => ({
      code: `${lane.slug}:${slugifyOffer(offer.name)}`,
      label: offer.name,
    })),
  })),
];

export const CONTACT_SERVICE_OPTIONS = CONTACT_SERVICE_OPTION_GROUPS.flatMap(
  (group) => group.options,
);

export const CONTACT_SERVICE_LOOKUP = Object.fromEntries(
  CONTACT_SERVICE_OPTIONS.map((option) => [option.code, option]),
);

export const CONTACT_SERVICE_COUNT =
  CONTACT_SERVICE_OPTIONS.length - 1;

export const DEFAULT_CONTACT_SERVICE_CODE = RECOMMENDATION_CODE;
export const DEFAULT_CONTACT_SERVICE_LABEL = RECOMMENDATION_LABEL;
